import {
  BgColorsOutlined,
  SaveOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Form, Input, InputNumber, Modal, Typography, message } from "antd";
import { useEffect, useState } from "react";
import PrinterSelect from "../PrinterSelect";
import { DEFAULT_COLOR_PROFILE } from "../specDefaults";
const { Text, Title } = Typography;

export default function ProviderFormModal({
  open,
  provider,
  onCancel,
  onSave,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue(
      provider || { sortOrder: 0, colorProfile: DEFAULT_COLOR_PROFILE },
    );
  }, [open, provider, form]);
  const submit = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await onSave(values);
    } catch (error) {
      if (!error.errorFields)
        message.error(error.response?.data?.message || error.message);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal
      className="specstudio-dialog-modal specstudio-provider-modal"
      open={open}
      onCancel={onCancel}
      onOk={submit}
      okText={provider ? "Lưu thay đổi" : "Thêm nhà in"}
      cancelText="Hủy"
      okButtonProps={{ icon: <SaveOutlined />, loading: saving }}
      width={620}
      destroyOnClose
      title={null}
    >
      <div className="specstudio-provider-modal-heading">
        <span className="specstudio-provider-modal-icon">
          <ShopOutlined />
        </span>
        <div>
          <Text className="specstudio-eyebrow">SPECSTUDIO · FULFILLMENT</Text>
          <Title level={2}>
            {provider ? "Chỉnh sửa nhà in" : "Thêm nhà in"}
          </Title>
          <Text type="secondary">
            Thiết lập thông tin nhà in dùng cho các quy cách sản phẩm.
          </Text>
        </div>
      </div>
      <Form form={form} layout="vertical" requiredMark>
        <section className="specstudio-provider-modal-section">
          <div className="specstudio-provider-modal-section-title">
            <span className="specstudio-section-index">01</span>
            <div>
              <Title level={5}>Thông tin nhà in</Title>
              <Text type="secondary">
                Chọn nhà in từ danh mục; tên nhà in được dùng làm nhãn tab
                trong trang sản phẩm.
              </Text>
            </div>
          </div>
          <Form.Item
            name="printerId"
            label="Tên nhà in"
            rules={[{ required: true, message: "Chọn nhà in" }]}
          >
            <PrinterSelect />
          </Form.Item>
          <Form.Item name="colorProfile" label="Hệ màu">
            <Input
              size="large"
              prefix={<BgColorsOutlined />}
              placeholder="VD: sRGB IEC61966-2.1"
            />
          </Form.Item>
          <Form.Item name="notes" label="Lưu ý riêng của nhà in">
            <Input.TextArea
              className="specstudio-notes-input"
              rows={4}
              placeholder="Yêu cầu riêng của nhà in này, ví dụ cách đặt tên file, quy trình gửi file…"
            />
          </Form.Item>
          <Form.Item name="sortOrder" label="Thứ tự hiển thị">
            <InputNumber
              min={0}
              size="large"
              style={{ width: "100%" }}
              placeholder="0"
            />
          </Form.Item>
        </section>
      </Form>
      <div className="specstudio-provider-modal-foot">
        <Text type="secondary">
          Có thể thêm vùng in và thông số sau khi tạo nhà in.
        </Text>
      </div>
    </Modal>
  );
}
